import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Key } from "lucide-react";
import { Button } from "@/components/ui/button";
import AuthLayout from "@/components/AuthLayout";
import { IconField, FormAlert } from "@/components/auth/IconField";

export const AccessCodeStep = ({ accessCode, onChange, onSubmit, loading, error }) => {
  const { t } = useTranslation();
  return <AuthLayout
    icon={Key}
    title={t("register.codeTitle")}
    subtitle={t("register.codeSubtitle")}
    footer={<>{t("register.alreadyHaveAccount")}{" "}
      <Link to="/login" data-testid="register-code-login" className="text-primary font-medium hover:underline">{t("register.signIn")}</Link>
    </>}>
    <div className="mb-4"><FormAlert message={error} testId="register-code-error" /></div>
    <form onSubmit={onSubmit} className="space-y-4">
      <IconField id="code" icon={Key} label={t("register.codeLabel")} hint={t("register.codeHint")}
        data-testid="register-access-code" type="text" autoFocus required
        placeholder={t("register.codePlaceholder")} className="uppercase tracking-widest"
        value={accessCode} onChange={(event) => onChange(event.target.value)} />
      <Button type="submit" data-testid="register-validate-code" disabled={loading} className="w-full h-12 font-medium">
        {t("register.codeValidate")}
      </Button>
    </form>
  </AuthLayout>;
};
